/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { toast } from "react-toastify";
import { listReviewData } from "../core/_requests";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../../component/Pagination";
import { DishReview } from "../core/_models";
import { useFormattedUtils } from "../../../component/dateUtils";
import SearchInput from "../../../component/core/Searchinput";
const ListDishReview = () => {
  const navigate = useNavigate();
  const { formatDateUS } = useFormattedUtils();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [listType, setListType] = useState<DishReview[]>([]);
  const [search, setSearch] = useState("");
  const chefId = currentUser?.uuid;
const [filter, setFilter] = useState("recent");
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dataSearch = searchParams.get("search");
  // useEffect to set the search term from URL (or local storage if needed)
  useEffect(() => {
  
    if (dataSearch !== null) {
      setSearch(dataSearch);
    }
  }, [dataSearch]);
  const filterData = {
    search: dataSearch,
    chefId
  };


useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const data = { search, chefId, filter }; 
      const res = await listReviewData(data);
      setListType(res?.data || []);
    } catch (error) {
      console.error("Error fetching Reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [chefId, search, filter]); 


  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clickApply = async () => {
    setLoading(true);
    const data = { search , chefId, filter };
    try {
      const res = await listReviewData(data);
      setListType(res?.data || []);
    } catch (error) {
      console.error("Error fetching Reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  const viewReview = (primaryId: string) => {
    navigate("/chef-review/view/" + primaryId);
  };

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listType.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(listType.length / itemsPerPage);

  const pageNumbers = Array.from({ length: pages }, (_, i) => i + 1);

  const renderStars = (rating: number | null) => {
    return rating !== null
      ? Array.from({ length: 5 }, (_, i) => (
          <span
            key={i}
            className={`material-symbols-outlined ${
              i < Math.floor(rating)
                ? "text-warning"
                : i === Math.floor(rating) && rating % 1 !== 0
                ? "text-warning"
                : ""
            }`}
          >
            {i < Math.floor(rating)
              ? "star"
              : i === Math.floor(rating) && rating % 1 !== 0
              ? "star_half"
              : "star_outline"}
          </span>
        ))
      : null;
  };
  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            <section className="row main-content">
              <div className="title mb-3">
                <h3 className="mb-0">Reviews ({listType.length})</h3>
              </div>
              <div className="col-12 title-btm">
               <SearchInput
                 value={search}
                     onChange={handleSearchChange}
                  onKeyUp={clickApply}

                  />
                    <select
                  className="form-select w-auto"
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                >
                  <option value="recent">Most Recent</option>
                  <option value="high">Highest Rating</option>
                  <option value="low">Lowest Rating</option>
                </select>
              </div>

              <div className="table-wrap mt-4">
                <table className="table custom-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>User Name</th>
                      <th>Dish Name</th>
                      <th>Description</th>
                      <th>Review</th>
                      <th>Date</th>
                      {/* <th>Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={6} className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : currentItems.length > 0 ? (
                      currentItems.map((item, i) => (
                        <tr key={item.primaryId}>
                          <td>{indexOfFirstItem + i + 1}</td>
                          <td>
                            <p className="mb-0">{item?.user?.name}</p>
                          </td>
                          <td>
                            <p className="mb-0">{item?.dish?.name}</p>
                          </td>
                          <td>
                            <p className="mb-0">{item.description}</p>
                          </td>
                          <td>
                            <div>{renderStars(item.reviews)}</div>
                          </td>
                          <td>
                            <p className="mb-0 type">{formatDateUS(item.date)}</p>
                          </td>
                          {/* <td>
                            <div className="action-item">
                              <a onClick={() => viewReview(item.primaryId)}>
                                <span className="material-symbols-outlined">
                                visibility
                                </span>
                              </a>
                            </div>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No Reviews Submitted – Stay Tuned!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Pagination
                data={listType}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default ListDishReview;
